import React from "react";
import { IconArrowNarrowRight } from "@tabler/icons-react";

const Business = () => {
  return (
    <div>
      <section className="section pt-5 " style={{ backgroundColor: "#f5f5fd" }}>
        <div className="container "  data-aos="fade-right">
          <div className="mx-auto text-center ">
            <h5 className="h5 mb-5 " style={{ color: "rgb(0, 109, 178)" }}>
              The Way We Go About Our Work
            </h5>
            <h3 className="h3 mb-4 text-n8 text-title ">
              How Cognity Assist Your Business
            </h3>
          </div>
          <div className="grid grid-cols-12 gap-6">
            {/* <!-- Card 1 --> */}
            <div className="group col-span-12 md:col-span-6 xl:col-span-3 border rounded shadow">
              <div className="relative z-[2] rounded-xl bg-n8 bg-right-top bg-no-repeat p-4 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.05)] duration-300 hover:bg-[url('')] group-hover:shadow-[0px_8px_40px_0px_rgba(0,0,0,0.15)] md:px-[30px] md:py-10">
                <h5 className="h5 mb-5 mt-8 text-title"> Discussion</h5>
                <p className="mb-6">
                  Before presenting a proposal, we prioritize meeting with our
                  clients face-to-face, allowing us to engage in detailed
                  discussions.
                </p>
                <a
                  href="/solutions"
                  className="flex items-center gap-2 font-medium "
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  {" "}
                  See Details{" "}
                  <IconArrowNarrowRight
                    className=" w-6 h-6"
                    style={{ color: "rgb(0, 109, 178)" }}
                  />
                </a>
              </div>
            </div>

            {/* <!-- Card 2 --> */}
            <div className="group col-span-12 md:col-span-6 xl:col-span-3">
              <div className="relative z-[2] rounded-xl bg-n8 bg-right-top bg-no-repeat p-4 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.05)] duration-300 hover:bg-[url('../images/element-7.html')] group-hover:shadow-[0px_8px_40px_0px_rgba(0,0,0,0.15)] md:px-[30px] md:py-10">
                <h5 className="h5 mb-5 mt-8 text-title">Ideas & concepts</h5>
                <p className="mb-6">
                  Our experts come up with all kinds of ideas and plans to make
                  sure that the IT services chosen have the best solutions.
                </p>
                <a
                  href="/solutions"
                  className="flex items-center gap-2 font-medium"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  {" "}
                  See Details{" "}
                  <IconArrowNarrowRight
                    className=" w-6 h-6"
                    style={{ color: "rgb(0, 109, 178)" }}
                  />
                </a>
              </div>
            </div>

            {/* <!-- Card 3 --> */}
            <div className="group col-span-12 md:col-span-6 xl:col-span-3">
              <div className="relative z-[2] rounded-xl bg-n8 bg-right-top bg-no-repeat p-4 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.05)] duration-300 hover:bg-[url('../images/element-7.html')] group-hover:shadow-[0px_8px_40px_0px_rgba(0,0,0,0.15)] md:px-[30px] md:py-10">
                <h5 className="h5 mb-5 mt-8 text-title">Testing & trying</h5>
                <p className="mb-6">
                  After we all agree on the ideas and plans, we'll carry them
                  out as planned and give feedback on the results and changes.
                </p>
                <a
                  href="/solutions"
                  className="flex items-center gap-2 font-medium"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  {" "}
                  See Details{" "}
                  <IconArrowNarrowRight
                    className=" w-6 h-6"
                    style={{ color: "rgb(0, 109, 178)" }}
                  />
                </a>
              </div>
            </div>

            {/* <!-- Card 4 --> */}
            <div className="group col-span-12 md:col-span-6 xl:col-span-3">
              <div className="relative z-[2] rounded-xl bg-n8 bg-right-top bg-no-repeat p-4 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.05)] duration-300 hover:bg-[url('../images/element-7.html')] group-hover:shadow-[0px_8px_40px_0px_rgba(0,0,0,0.15)] md:px-[30px] md:py-10">
                <h5 className="h5 mb-5 mt-8 text-title">Execute & install</h5>
                <p className="mb-6">
                  Once the final blueprint has been accepted, everything will be
                  carried out in accordance with the signed contract.
                </p>
                <a
                  href="/solutions"
                  className="flex items-center gap-2 font-medium "
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  {" "}
                  See Details{" "}
                  <IconArrowNarrowRight
                    className=" w-6 h-6"
                    style={{ color: "rgb(0, 109, 178)" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Business;
